import config from '../config.json';

export const featuresServiceApiFactory = (
    httpServiceApi
) => {
    const baseUrl = config.FEATURES_API_URL;
    let response = {};
    const onFailure = error => {
        response.error = error;
    };

    const getClientFeatures = async () => {
        response.features = await httpServiceApi.sendRequest(
            `${baseUrl}/client-features`,
            null,
            {
                onFailure
            }
        );
        return response;
    };

    return {
        getClientFeatures
    }
};